import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 3x5, 4 - 1x2',
  imageCount: 5,
  displayGroup: 'DG_3X5_WALLET',
  calc: (height) => {
    const p1Width = height / 4;
    const p1Height = (height / 4) * ASPECT_RATIO;
    const p5Width = height / 2;
    const p5Height = (height / 2) * ASPECT_RATIO;

    return {
      gridTemplate: () => `
        'p1 p2 p5' ${p1Width}px
        'p3 p4 p5' ${p1Width}px
        '. . .' ${height / 2}px
        / ${p1Height}px ${p1Height}px ${p5Height}px`,
      photos: [
        ...gridPhotos(1, 4, p1Width, p1Height, -90),
        {
          gridArea: 'p5',
          width: p5Width,
          height: p5Height,
          rotation: -90
        }
      ]
    };
  }
};
